import { render, staticRenderFns } from "./FarmaciaEntradas.vue?vue&type=template&id=6f7076a4&scoped=true&"
import script from "./FarmaciaEntradas.vue?vue&type=script&lang=js&"
export * from "./FarmaciaEntradas.vue?vue&type=script&lang=js&"
import style0 from "./FarmaciaEntradas.vue?vue&type=style&index=0&id=6f7076a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7076a4",
  null
  
)

export default component.exports